import api from "./axios";

export interface LoginPayload {
    username: string;
    password: string;
}

export const loginApi = (data: LoginPayload) => {
    return api.post("/auth/login", data);
};

export const verifyOtpApi = (data: { username: string; otp: string }) => {
    return api.post("/auth/verifyotp", data);
};

export const logoutApi = (data: { username: string; roleid: number | string; employeeid: number | string }) => {
    return api.post("/auth/logout", data);
};
